import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import EditIcon from '@mui/icons-material/Edit'
import { RequiredExpertDtoIds } from '@toktokdoctech/tokapi-client'
import PhysicianStatus from './PhysicianStatus'
import dayjs from 'dayjs'
import DataTableActions from '../../Common/dataTableActions/DataTableActions'
import { GetHeadersParams } from './_props'

export const getHeaders = ({ sort, handleSort, large }: GetHeadersParams) => {
    const largeHeaders = [
        {
            buttonProps: {
                endIcon: sort === 'descending' ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />,
                disableElevation: true,
                onClick: handleSort,
            },
            label: 'Nom',
        },
        {
            label: 'Prénom',
        },
    ]

    const smallHeaders = [
        {
            label: 'Médecin',
        },
    ]

    const headers = [
        {
            label: 'Statut',
        },
        {
            label: 'Spécialité',
        },
        {
            label: large ? 'Dernière invitation' : 'Invitation',
        },
        {
            label: 'Actions',
            size: 'sm',
            orientation: 'center',
        },
    ]

    if (large) {
        return [...largeHeaders, ...headers]
    }

    return [...smallHeaders, ...headers]
}

export const describeRows = (row: RequiredExpertDtoIds, large: boolean) => {
    const largeRows = [
        {
            item: row.lastName.toUpperCase(),
        },
        {
            item: row.firstName,
        },
    ]

    const smallRows = [
        {
            item: `${row.lastName.toUpperCase()} ${row.firstName}`,
        },
    ]
    const status = row?.status.toLowerCase()
    const rows = [
        {
            item: <PhysicianStatus status={status} />,
        },
        {
            item: row?.speciality,
        },
        {
            item: row?.lastInvitationDate ? dayjs(row.lastInvitationDate).format('DD/MM/YYYY') : '',
        },
        {
            item: (
                <DataTableActions
                    actions={[
                        {
                            icon: <EditIcon titleAccess="Modifier un téléconsultant" />,
                            to: `/expert/${row?.id}`,
                            dataCy: 'editExpert',
                        },
                    ]}
                />
            ),
            orientation: 'end' as const,
        },
    ]

    if (large) {
        return [...largeRows, ...rows]
    }

    return [...smallRows, ...rows]
}
